import { useState, useEffect } from "react";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import http from "../api/server";
import { IconButton } from "@mui/material";
import useGetClientId from "../hooks/useGetClientId";
import {
  ADD_BLOCK_BY_CLIENT_ID,
  DELETE_PROPERTY_BY_MASTER_ID,
  GET_ALL_PROPERTY_BY_CLIENT_ID,
  GET_BLOCK_BY_CLIENT_ID,
  GET_USERS_ROLE_BY_CLIENT_ID,
  GET_PROPERTIES_LIST,
  RMS_LINK,
} from "../api/apiPath";
import Toaster from "./common/Toaster";
import { useSelector } from "react-redux";
import UpdateProperty from "./UpdateProperty";
import useGetCity from "../hooks/useGetCity";
import DynamicTable from "./common/DynamicTable";
import DynamicTiles from "./common/DynamicTiles";
import ConfirmationPopup from "./common/ConfirmationPopup";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
import AddSiteBlock from "./AddSiteBlock";
// import del from "../assets/img/del.png";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import ClearIcon from "@mui/icons-material/Clear";
import searchIcon from "../assets/img/searchIcon.png";
import AddIcon from "@mui/icons-material/Add";
import AutocompleteInput from "./common/AutocompleteInput";
import activeHistoryIcon from "../assets/img/activeHistoryIcon.png";
// import activeEditIcon from "../assets/img/activeEditIcon.png";
// import activeDeleteIcon from "../assets/img/aciveDeleteIcon.png";
import PropertyList from "./Property/Property";
// import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const AddBlockModalPopup = ({
  setShowAddBlockModal,
  addNewBlockValue,
  setAddNewBlockValue,
  handleAddBlock,
  hanleSaveBlock,
}) => {
  return (
    <div className="dashboard_body_main d-flex vh-100">
      <div className="d-flex dashboard_body flex-column py-3 ">
        <div className="modal-overlay">
          <div
            className="approval-modal-content"
            style={{ height: "fit-content" }}
          >
            <span
              className="close"
              onClick={() => {
                setShowAddBlockModal(false);
                setAddNewBlockValue("");
              }}
            >
              &times;
            </span>
            <h6 className="modal-header">Add Block</h6>

            <div className="modal-body">
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="address1"
                  placeholder=" "
                  value={addNewBlockValue}
                  onChange={handleAddBlock}
                  required
                />
                <label htmlFor="address1">Add Block</label>
              </div>

              <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-3">
                <button
                  type="button"
                  className="btn btn-tertiary"
                  onClick={() => {
                    setShowAddBlockModal(false);
                    setAddNewBlockValue("");
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={hanleSaveBlock}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddProperty = () => {
  const [toolbar, setToolBar] = useState({
    searchText: "",
    property_name: "Propertyname",
    property_address: "Propertyaddress",
    inspector: "Inspector",
    approver: "Approver",
    propertyType: "Property Type",
  });
  const isAnyFilterApplied =
    toolbar.searchText !== "" ||
    toolbar.property_name !== "Propertyname" ||
    toolbar.inspector !== "Inspector" ||
    toolbar.approver !== "Approver" ||
    toolbar.propertyType !== "Property Type";

  const { userObj } = useSelector((state) => state.user);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [blocksList, setBlocksList] = useState(null);
  const [approverList, setApproverList] = useState(null);
  const [inspectorList, setInspectorList] = useState(null);
  const [allPropertyList, setAllPropertyList] = useState(null);
  const [editProperty, setEditProperty] = useState(null);
  const [showAddBlockModal, setShowAddBlockModal] = useState(false);
  const [addNewBlockValue, setAddNewBlockValue] = useState("");
  const [renderAddProperty, setRenderAddProperty] = useState(false);
  const [renderUpdateProperty, setRenderUpdateProperty] = useState(false);
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const cityObj = useGetCity();
  const [activeView, setActiveView] = useState("tile");
  const navigate = useNavigate();
  const { clientNameParam } = useParams();
  const [properties, setProperties] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [showRmsLinkPopup, setShowRmsLinkPopup] = useState(false);
  const [rmsLinkData, setRmsLinkData] = useState({
    description: "",
    href: "",
  });

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const filteredRows = allPropertyList?.filter((row) => {
    const matchesSearch =
      !toolbar.searchText ||
      row.propertyName
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      row.propertyLocation
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      row.propertyStatus
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      (Array.isArray(row.inspectors) &&
        row.inspectors.some((inspector) =>
          inspector.fullName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()),
        )) ||
      (Array.isArray(row.approvers) &&
        row.approvers.some((approver) =>
          approver.fullName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()),
        ));

    const matchesName =
      toolbar.property_name === "Propertyname" ||
      row.propertyName === toolbar.property_name;

    const matchesInspector =
      toolbar.inspector === "Inspector" ||
      (Array.isArray(row.inspectors) &&
        row.inspectors.some(
          (inspector) => inspector.fullName === toolbar.inspector,
        ));

    const matchesApprover =
      toolbar.approver === "Approver" ||
      (Array.isArray(row.approvers) &&
        row.approvers.some(
          (approver) => approver.fullName === toolbar.approver,
        ));

    const matchesUserType =
      toolbar.propertyType === "Property Type" ||
      row.propertyStatus === toolbar.propertyType;

    return (
      matchesSearch &&
      matchesName &&
      matchesInspector &&
      matchesApprover &&
      matchesUserType
    );
  });
  const allInspectors = Array.isArray(allPropertyList)
    ? allPropertyList.flatMap((property) =>
        Array.isArray(property.inspectors) ? property.inspectors : [],
      )
    : [];

  const uniqueInspectors = [
    ...new Map(
      allInspectors.map((inspector) => [inspector.userId, inspector]),
    ).values(),
  ];

  const allApprovers = Array.isArray(allPropertyList)
    ? allPropertyList.flatMap((property) =>
        Array.isArray(property.approvers) ? property.approvers : [],
      )
    : [];

  const uniqueApprovers = [
    ...new Map(
      allApprovers.map((approver) => [approver.userId, approver]),
    ).values(),
  ];

  const propertyNameList = [
    ...new Map(
      allPropertyList?.map((item) => [
        item.propertyName,
        { name: item.propertyName },
      ]) || [],
    ).values(),
  ].filter((item) => item.name);

  const inspectorNameList = [
    ...new Map(
      uniqueInspectors?.map((item) => [
        item.fullName,
        { name: item.fullName },
      ]) || [],
    ).values(),
  ].filter((item) => item.name);

  const approverNameList = [
    ...new Map(
      uniqueApprovers?.map((item) => [
        item.fullName,
        { name: item.fullName },
      ]) || [],
    ).values(),
  ].filter((item) => item.name);

  const mapSiteNameList = [
    ...new Map(
      properties?.map((item) => [item.name, { name: item.name }]) || [],
    ).values(),
  ].filter((item) => item.name);

  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  // const navigate = useNavigate();
  const clientObj = useGetClientId();

  const getBlockByClientID = async (clientId) => {
    try {
      const response = await http.get(
        GET_BLOCK_BY_CLIENT_ID + "?clientId=" + clientId,
      );
      if (response.status === 200) {
        setBlocksList(response?.data?.blocks);
      }
    } catch (error) {
      return error;
    }
  };

  const getUsersRoleByClientId = async (clientId) => {
    try {
      const response = await http.get(
        GET_USERS_ROLE_BY_CLIENT_ID + "?clientId=" + clientId,
      );
      if (response.status === 200) {
        // Filter roles
        const approvers = response?.data?.filter(
          (item) => item.roleName === "Approver" && item.active === true,
        );
        const inspectors = response?.data?.filter(
          (item) => item.roleName === "Inspector" && item.active === true,
        );

        // Dropdown options
        const approverOptions = approvers.map((a) => ({
          value: a.userId,
          label: a.fullName,
        }));

        const inspectorOptions = inspectors.map((i) => ({
          value: i.userId,
          label: i.fullName,
        }));
        setInspectorList(inspectorOptions);
        setApproverList(approverOptions);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    if (clientObj.clientId) {
      getBlockByClientID(clientObj.clientId);
      handleGetAllPropertyByClinetID(clientObj.clientId);
      getUsersRoleByClientId(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  // const handleGetAllPropertyByClinetID = async (clientId) => {
  //   try {
  //     const response = await http.get(
  //       GET_ALL_PROPERTY_BY_CLIENT_ID + "?clientId=" + clientId,
  //     );
  //     if (response.status === 200) {
  //       console.log("response.data", response.data);
  //       response?.data?.forEach((item) => {
  //         item.id = item.propertyMasterId; // Assigning a sequential ID
  //       });
  //       setAllPropertyList(response.data);
  //     }
  //   } catch (error) {
  //     return error;
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_BY_CLIENT_ID + "?clientId=" + clientId,
      );
      if (response.status === 200) {
        console.log("response.data", response.data);
        response?.data?.forEach((item) => {
          item.id = item.propertyMasterId; // Assigning a sequential ID
        });
        setAllPropertyList(response.data);
        // Also refresh the properties list for map view dropdown
        fetchPropertiesList();
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  };
  const hanleSaveBlock = async () => {
    try {
      const response = await http.post(ADD_BLOCK_BY_CLIENT_ID, {
        clientId: clientObj.clientId,
        blockName: addNewBlockValue,
      });
      if (response.status !== 400) {
        setShowAddBlockModal(false);
        setAddNewBlockValue("");
        getBlockByClientID(clientObj.clientId);
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response?.data?.message,
        });
      }
    } catch (error) {
      return error;
    }
  };

  const handleAddBlock = (e) => {
    setAddNewBlockValue(e.target.value);
  };

  const handleEditProperty = (id) => {
    const editPropertyDetails = allPropertyList?.filter((data) => {
      return data.propertyMasterId === id;
    });
    setEditProperty(editPropertyDetails);
    setRenderUpdateProperty(true);
  };

  const handleDeleteProperty = async (data) => {
    // const newFormPayload = {
    //   clientId: clientObj.clientId,
    //   propertyMasterId: data?.propertyMasterId,
    // blockName: data.blockName,
    // blockId: data.blockId,
    // isActive: false,
    // propertyName: data.propertyName,
    // propertyLocation: data.propertyAddress || "",
    // postalCode: data.propertyPostalCode || "",
    // propertyImage: data.propertyImage || "",
    // cityId: data.cityId.toString() || "",
    // inspectors: (data.inspectors || []).map((i) => i.userId ?? i),
    // approvers: (data.approvers || []).map((i) => i.userId ?? i),
    // complianceDocs: data.complianceDocs || [],
    // totalNoOfFloors: parseInt(data.totalNoOfFloors, 10) || 0,
    // propertyStatus: data.propertyStatus || "Active",
    // };
    try {
      const response = await http.delete(
        DELETE_PROPERTY_BY_MASTER_ID +
          `?propertyMasterId=${data?.propertyMasterId}&ClientId=${clientObj.clientId}&LoggedinUserEMail=${userObj?.userEmail}`,
      );
      // if (response.status === 200 && response?.data?.result?.isSuccess) {
      //   setTimeout(() => {
      //     setToastData({
      //       toastShow: true,
      //       toastType: "success",
      //       toastString: response?.data?.result?.message,
      //     });
      //   }, 2000);

      //   // setShowUpdatePropertyModal(false);
      //   handleGetAllPropertyByClinetID(clientObj.clientId);
      // }
      // if (response.status === 200 && response?.data?.result?.isSuccess) {
      //   setToastData({
      //     toastShow: true,
      //     toastType: "success",
      //     toastString: response?.data?.result?.message,
      //   });

      //   handleGetAllPropertyByClinetID(clientObj.clientId);
      // }
      if (response.status === 200 && response?.data?.result?.isSuccess) {
        console.log("delete api call in click");
        setToastData({
          toastShow: true,
          toastType: "success",
          // toastString: response?.data?.result?.message,
          toastString: "Property has been successfully deleted.",
        });

        setTimeout(() => {
          handleGetAllPropertyByClinetID(clientObj.clientId);
        }, 300);
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: response?.data?.result?.message,
          });
        }, 2000);
      }
    } catch (error) {
      return error;
    }
  };
  useEffect(() => {
    if (!clientObj?.clientId) return;
    fetchPropertiesList();
  }, [clientObj?.clientId]);
  const fetchPropertiesList = async () => {
    try {
      const response = await http.get(
        `${GET_PROPERTIES_LIST}?clientId=${clientObj?.clientId}`,
      );

      if (response.status === 200) {
        setProperties(response.data);
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
    } finally {
      setLoading(false);
    }
  };

  const RESET_TILE_FILTERS = {
    searchText: "",
    property_name: "Propertyname",
    inspector: "Inspector",
    approver: "Approver",
    propertyType: "Property Type",
  };

  const RESET_MAP_FILTERS = {
    searchText: "",
    name: "",
  };
  const handleTileViewClick = () => {
    setActiveView("tile");
    setToolBar((prev) => ({
      ...prev,
      ...RESET_TILE_FILTERS,
      name: "", // clear map-only field
    }));
  };

  // const handleMapViewClick = () => {
  //   setActiveView("map");
  //   setToolBar((prev) => ({
  //     ...prev,
  //     ...RESET_MAP_FILTERS,
  //     property_name: "Propertyname",
  //     inspector: "Inspector",
  //     approver: "Approver",
  //     propertyType: "Property Type",
  //   }));
  // };
  const handleMapViewClick = () => {
    setActiveView("map");
    setToolBar((prev) => ({
      ...prev,
      ...RESET_MAP_FILTERS,
      property_name: "Propertyname",
      inspector: "Inspector",
      approver: "Approver",
      propertyType: "Property Type",
    }));
    // Refresh properties list when switching to map view
    if (clientObj?.clientId) {
      fetchPropertiesList();
    }
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const tableColumns = [
    {
      field: "Actions",
      headerName: "Actions",
      width: 120,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: false,
      filterable: false,
      type: "string",
      minWidth: 120,
      flex: 0.4,
      renderCell: (params) => (
        <IconButton size="small" onClick={(e) => handleMenuOpen(e, params.row)}>
          <MoreVertIcon />
        </IconButton>
      ),
      renderHeader: () => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <span className="personalFont">Actions</span>

          <i
            className="bi bi-info-circle"
            style={{
              fontSize: "0.9rem",
              marginLeft: "5px",
              cursor: "pointer",
            }}
            title="Click the three dots menu for each Site to access edit/delete site details, create inspection and view inspection history, also generate RMS link for each site."
          ></i>
        </span>
      ),
    },
    {
      field: "propertyName",
      height: 50,
      width: 250,
      minWidth: 250,
      headerName: "Property Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "propertyLocation",
      height: 50,
      width: 220,
      minWidth: 220,
      headerName: "Property Address",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "numberOfBlocks",
      width: 70,
      height: 50,
      headerName: "Number of Building",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 70,
      flex: 1,
      renderCell: (data) => {
        return (
          <>
            {data?.row?.numberOfBlocks === null
              ? "-"
              : data?.row?.numberOfBlocks}
          </>
        );
      },
    },
    {
      field: "inspectors",
      headerName: "Inspector(s)",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 220,
      flex: 1,
      renderCell: (data) => {
        return (
          <>{data?.row?.inspectors?.map((item) => item.fullName).join(", ")}</>
        );
      },
    },
    {
      field: "approvers",
      headerName: "Approver(s)",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 220,
      flex: 1,
      renderCell: (data) => {
        return (
          <>{data?.row?.approvers?.map((item) => item.fullName).join(", ")}</>
        );
      },
    },

    {
      field: "propertyStatus",
      headerName: "Property Type",
      width: 60,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 60,
      flex: 0.6,
    },

    // {
    //   field: "Actions",
    //   headerName: "Actions",
    //   width: 60,
    //   height: 50,
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: false,
    //   filterable: false,
    //   type: "string",
    //   minWidth: 60,
    //   flex: 1,
    //   renderCell: (data) => (
    //     <Box>
    //       <img
    //         tabIndex={0}
    //         title="Edit Property"
    //         alt="Edit Property"
    //         onClick={() => {
    //           handleEditProperty(data?.row?.propertyMasterId);
    //         }}
    //         src={activeEditIcon}
    //         style={{ cursor: "pointer" }}
    //       ></img>

    //       <img
    //         tabIndex={0}
    //         title="Delete Property"
    //         alt="Delete Property"
    //         onClick={() => {
    //           setPropertyToDelete(data?.row);
    //           setShowDeleteModal(true);
    //         }}
    //         src={activeDeleteIcon}
    //         style={{ cursor: "pointer" }}
    //       ></img>
    //     </Box>
    //   ),
    // },
  ];

  const generateRmsLink = async (row) => {
    try {
      setLoading(true);

      const response = await http.put(
        `${RMS_LINK}?clientId=${clientObj.clientId}&propertyMasterId=${row.propertyMasterId}`,
      );

      if (response.status === 200 && response.data?.isSuccess) {
        const newUrl = response.data?.rmsPropertyUrl;

        // setRmsLinkData({
        //   description: `RMS link for ${row.propertyName}`,
        //   href: newUrl,
        // });
        setRmsLinkData({
          description: (
            <>
              <strong> RMS link for {row.propertyName}</strong>
            </>
          ),
          href: newUrl,
        });

        setShowRmsLinkPopup(true);

        setAllPropertyList((prev) =>
          prev.map((item) =>
            item.propertyMasterId === row.propertyMasterId
              ? { ...item, rmsPropertyUrl: newUrl }
              : item,
          ),
        );

        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: response.data?.message,
        });
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response.data?.message || "Failed to generate RMS link",
        });
      }
    } catch (error) {
      console.error(error);
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: "Something went wrong while generating RMS link",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            if (!selectedRow) return;

            const existingUrl = selectedRow?.rmsPropertyUrl;

            if (existingUrl) {
              const formattedUrl = existingUrl.startsWith("http")
                ? existingUrl
                : `https://${existingUrl}`;

              // setRmsLinkData({
              //   description: `RMS link for ${selectedRow.propertyName}`,
              //   href: formattedUrl,
              // });
              setRmsLinkData({
                description: (
                  <>
                    <strong> RMS link for {selectedRow.propertyName}</strong>
                  </>
                ),
                href: formattedUrl,
              });

              setShowRmsLinkPopup(true);
            } else {
              generateRmsLink(selectedRow);
            }

            handleMenuClose();
          }}
        >
          <i className="fa-solid fa-link" style={{ marginRight: 8 }} />
          RMS Link
        </MenuItem>
        <MenuItem
          onClick={() => {
            const path = generatePath(
              "/client/:clientNameParam/viewInspectionHistory/:propertyMasterId",
              {
                clientNameParam: clientNameParam,
                propertyMasterId: selectedRow?.propertyMasterId,
              },
            );

            navigate(path, {
              state: {
                propertyName: selectedRow?.propertyName,
              },
            });
            handleMenuClose();
          }}
        >
          {/* <i className="fa-solid fa-eye fa-sm" style={{ marginRight: 8 }} />
           */}
          <img
            src={activeHistoryIcon}
            width={16}
            style={{
              marginRight: 8,
              filter: "brightness(0)",
            }}
          />
          View Inspection History
        </MenuItem>
        <MenuItem
          onClick={() => {
            const path = generatePath("/client/:clientNameParam/inspection", {
              clientNameParam,
            });

            navigate(path, {
              state: {
                propertyMasterId: selectedRow?.propertyMasterId,
                propertyName: selectedRow?.propertyName,
              },
            });

            handleMenuClose();
          }}
        >
          <AddIcon fontSize="small" sx={{ mr: 1 }} />
          Create Inspection
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleEditProperty(selectedRow?.propertyMasterId);
            handleMenuClose();
          }}
        >
          <EditIcon fontSize="small" sx={{ mr: 1 }} />
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {
            setPropertyToDelete(selectedRow);
            setShowDeleteModal(true);
            handleMenuClose();
          }}
        >
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
          Delete
        </MenuItem>
      </Menu>

      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main paddingClassForAddProperty">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <>
            {renderAddProperty ? (
              <AddSiteBlock
                setRenderAddProperty={setRenderAddProperty}
                blocksList={blocksList}
                clientId={clientObj.clientId}
                handleGetAllPropertyByClinetID={handleGetAllPropertyByClinetID}
              />
            ) : renderUpdateProperty ? (
              <UpdateProperty
                setRenderUpdateProperty={setRenderUpdateProperty}
                blocksList={blocksList}
                editPropertyDetails={editProperty[0]}
                clientId={clientObj.clientId}
                handleGetAllPropertyByClinetID={handleGetAllPropertyByClinetID}
                cityList={city}
                inspectorList={inspectorList}
                approverList={approverList}
                setToastData={setToastData}
              />
            ) : (
              <div className="d-flex dashboard_body flex-column py-1 w-100">
                <div className="w-100">
                  <div className="col-sm-12 d-flex justify-content-between m-0 mt-3 align-items-end">
                    <div className="text-start">
                      <p className="fs-3 fw-bold m-0">Properties</p>
                      <p className="fs-6 m-0">
                        Manage and track all properties.
                      </p>
                    </div>
                    <div className="col-auto ms-auto">
                      <button
                        type="button"
                        className="btn btn-primary custom_toolbar_btn mx-2"
                        onClick={() => {
                          setRenderAddProperty(true);
                        }}
                      >
                        <i className=" fa-solid fa-plus addBlock"></i> Add New
                        Site
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary custom_toolbar_btn"
                        onClick={() =>
                          navigate(
                            generatePath(
                              "/client/:clientNameParam/inspection",
                              {
                                clientNameParam,
                              },
                            ),
                          )
                        }
                      >
                        <i className=" fa-solid fa-plus addBlock"></i> New
                        Inspection
                      </button>
                    </div>
                  </div>

                  <div className="row py-3 align-items-center g-3">
                    {activeView === "tile" && (
                      <>
                        {/* Search Bar */}
                        <div className="custom_toolbar_search col-6 col-md-3">
                          <img src={searchIcon} />
                          <input
                            type="text"
                            className="form-control custom_toolbar_control"
                            placeholder="Search properties..." // kept your text
                            value={toolbar.searchText}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                searchText: e.target.value,
                              })
                            }
                          />
                        </div>
                        {/* Dropdowns */}
                        <div className="col-6 col-md-2">
                          {/* <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.property_name}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                property_name: e.target.value,
                              })
                            }
                          >
                            <option value="Propertyname">Site Name</option>
                            {[
                              ...new Set(
                                allPropertyList?.map(
                                  (user) => user.propertyName,
                                ),
                              ),
                            ]
                              .sort((a, b) => a.localeCompare(b))
                              .map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                          </select> */}

                          <AutocompleteInput
                            masterList={propertyNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={
                              toolbar.property_name === "Propertyname"
                                ? ""
                                : toolbar.property_name
                            }
                            onValueChange={(value) =>
                              setToolBar({
                                ...toolbar,
                                property_name: value || "Propertyname",
                              })
                            }
                            placeholder="Building Name"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Site not found"
                          />
                        </div>

                        <div className="col-6 col-md-2">
                          {/* <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.inspector}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                inspector: e.target.value,
                              })
                            }
                          >
                            <option value="Inspector">Inspector(s)</option>
                            {uniqueInspectors
                              .sort((a, b) =>
                                a.fullName.localeCompare(
                                  b.fullName,
                                  undefined,
                                  {
                                    sensitivity: "base",
                                  },
                                ),
                              )

                              .map((inspector) => (
                                <option
                                  key={inspector.userId}
                                  value={inspector.fullName}
                                >
                                  {inspector.fullName}
                                </option>
                              ))}
                          </select> */}

                          <AutocompleteInput
                            masterList={inspectorNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={
                              toolbar.inspector === "Inspector"
                                ? ""
                                : toolbar.inspector
                            }
                            onValueChange={(value) =>
                              setToolBar({
                                ...toolbar,
                                inspector: value || "Inspector",
                              })
                            }
                            placeholder="Inspector(s)"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Inspector not found"
                          />
                        </div>

                        <div className="col-6 col-md-2">
                          {/* <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.approver}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                approver: e.target.value,
                              })
                            }
                          >
                            <option value="Approver">Approver(s)</option>
                            {uniqueApprovers
                              .sort((a, b) =>
                                a.fullName.localeCompare(
                                  b.fullName,
                                  undefined,
                                  {
                                    sensitivity: "base",
                                  },
                                ),
                              )
                              .map((approver) => (
                                <option
                                  key={approver.userId}
                                  value={approver.fullName}
                                >
                                  {approver.fullName}
                                </option>
                              ))}
                          </select> */}
                          <AutocompleteInput
                            masterList={approverNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={
                              toolbar.approver === "Approver"
                                ? ""
                                : toolbar.approver
                            }
                            onValueChange={(value) =>
                              setToolBar({
                                ...toolbar,
                                approver: value || "Approver",
                              })
                            }
                            placeholder="Approver(s)"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Approver not found"
                          />
                        </div>

                        <div className="col-6 col-md-1">
                          <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.propertyType}
                            onChange={(e) =>
                              setToolBar({
                                ...toolbar,
                                propertyType: e.target.value,
                              })
                            }
                          >
                            <option value="Property Type">Type</option>
                            {[
                              ...new Set(
                                allPropertyList?.map(
                                  (user) => user.propertyStatus,
                                ),
                              ),
                            ]
                              .sort((a, b) => a.localeCompare(b))
                              .map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                          </select>
                        </div>
                      </>
                    )}
                    {activeView === "map" && (
                      <>
                        {/* Search Bar */}
                        <div className="custom_toolbar_search col-6 col-md-3">
                          <img src={searchIcon} />
                          <input
                            type="text"
                            className="form-control custom_toolbar_control"
                            placeholder="Search properties"
                            value={toolbar.searchText}
                            onFocus={() => {
                              setToolBar((prev) => ({
                                ...prev,
                                name: "",
                                property_name: "Propertyname",
                              }));
                            }}
                            onChange={(e) => {
                              const value = e.target.value;
                              setToolBar((prev) => ({
                                ...prev,
                                searchText: value,
                                name: "",
                              }));
                            }}
                          />
                        </div>
                        {/* Dropdowns */}
                        {/* <div className="col-6 col-md-2">
                          <select
                            className="form-select custom_toolbar_control"
                            value={toolbar.name}
                            onChange={(e) =>
                              setToolBar((prev) => ({
                                ...prev,
                                name: e.target.value,
                                searchText: "",
                              }))
                            }
                          >
                            <option value="">Site Name</option>

                            {[...new Set(properties.map((p) => p.name))]
                              .filter(Boolean)
                              .map((name, index) => (
                                <option key={index} value={name}>
                                  {name}
                                </option>
                              ))}
                          </select>
                        </div> */}
                        <div className="col-6 col-md-2">
                          <AutocompleteInput
                            masterList={mapSiteNameList}
                            getOptionLabel={(item) => item?.name || ""}
                            getOptionValue={(item) => item?.name || ""}
                            value={toolbar.name || ""}
                            onValueChange={(value) =>
                              setToolBar((prev) => ({
                                ...prev,
                                name: value || "",
                                searchText: value ? "" : prev.searchText,
                              }))
                            }
                            placeholder="Building Name"
                            inputClassName="form-control custom_toolbar_control mt-1"
                            notFoundText="Site not found"
                          />
                        </div>
                      </>
                    )}
                    <div className="col-1 ms-auto property-view-toggle ">
                      <div
                        className={`slider ${activeView === "map" ? "right" : "left"}`}
                      />

                      <button
                        className={`btn custom_toolbar_btn view-btn ${
                          activeView === "tile" ? "active" : ""
                        }`}
                        onClick={handleTileViewClick}
                      >
                        <i className="fa fa-list" aria-hidden="true"></i>
                      </button>

                      <button
                        className={`btn custom_toolbar_btn view-btn ${
                          activeView === "map" ? "active" : ""
                        }`}
                        onClick={handleMapViewClick}
                      >
                        <i className="fas fa-map-marker-alt"></i>
                      </button>
                    </div>

                    {/* <div className="col-6 col-md-1">
                  <button
                        type="button"
                        className="btn btn-primary custom_toolbar_btn mx-2"
                      >
                        Tile view
                      </button>
                    </div>
                    <div className="col-6 col-md-1">
                    <button
                        type="button"
                        className="btn btn-primary custom_toolbar_btn mx-2"
                      >
                       Map View
                      </button>
                    </div> */}
                    {isAnyFilterApplied && (
                      <div style={{ width: "auto", paddingLeft: "0px" }}>
                        <IconButton
                          tabIndex={0}
                          title="Clear Filters"
                          onClick={() => {
                            setToolBar({
                              searchText: "",
                              property_name: "Propertyname",
                              inspector: "Inspector",
                              approver: "Approver",
                              propertyType: "Property Type",
                            });
                          }}
                        >
                          <ClearIcon
                            sx={{ color: "#717186" }}
                            fontSize="small"
                          />
                        </IconButton>
                      </div>
                    )}

                    {/* Export Button */}
                  </div>
                  {activeView === "tile" && (
                    <div
                      className="inspection-table"
                      style={{ paddingTop: "10px" }}
                    >
                      <DynamicTable
                        tableData={filteredRows}
                        columnsValue={tableColumns}
                        pageSize={10}
                        rowHeight={45}
                        pageSizeOptions={[
                          100,
                          150,
                          200,
                          { value: -1, label: "All" },
                        ]}
                      />
                    </div>
                  )}
                  <div
                    style={{ display: activeView === "map" ? "block" : "none" }}
                  >
                    <PropertyList
                      searchText={toolbar.searchText}
                      propertyName={toolbar.name}
                      key={activeView}
                    />
                  </div>
                  <div className="inspection-tile">
                    {filteredRows &&
                      filteredRows?.map((item) => {
                        return (
                          // eslint-disable-next-line react/jsx-key
                          <DynamicTiles
                            tableData={item}
                            module="addPropertyDashboard"
                            setPropertyToDelete={setPropertyToDelete}
                            setShowDeleteModal={setShowDeleteModal}
                            handleEditProperty={() =>
                              handleEditProperty(item.propertyMasterId)
                            }
                          />
                        );
                      })}
                  </div>
                </div>
              </div>
            )}
            <Footer />
            <div className="bottom-bar-spacing"></div>
            <BottomBarIcons />
            <LoadingComponent loading={loading} />
            {showAddBlockModal && (
              <AddBlockModalPopup
                setShowAddBlockModal={setShowAddBlockModal}
                addNewBlockValue={addNewBlockValue}
                setAddNewBlockValue={setAddNewBlockValue}
                handleAddBlock={handleAddBlock}
                hanleSaveBlock={hanleSaveBlock}
              />
            )}
            {showDeleteModal && (
              <ConfirmationPopup
                show={showDeleteModal}
                headingText="Confirm Delete"
                infoText="Are you sure you want to delete this property? Deleting property will mark all the existing active inspections as canceled."
                cancelText="Cancel"
                submitText="Yes, Delete"
                onCancel={() => {
                  setShowDeleteModal(false);
                  setPropertyToDelete(null);
                }}
                onSubmit={() => {
                  if (propertyToDelete) {
                    handleDeleteProperty(propertyToDelete);
                  }
                  setShowDeleteModal(false);
                }}
              />
            )}

            {showRmsLinkPopup && (
              <div className="modal-overlay">
                <div
                  className="approval-modal-content"
                  style={{ height: "auto" }}
                >
                  <i
                    className="fa-solid fa-xmark fa-sm close-icon mt-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowRmsLinkPopup(false)}
                  ></i>

                  <div className="modal-body p-3">
                    {/* <h6 className="mb-3 fw-semibold">RMS Link</h6> */}

                    <h6 className="text-muted mb-2">
                      {rmsLinkData.description}
                    </h6>

                    <div className="form-group">
                      {/* <label className="fw-semibold">Link</label> */}
                      <div
                        className="p-2 mt-1"
                        style={{
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          wordBreak: "break-all",
                        }}
                      >
                        <a
                          href={rmsLinkData.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary"
                        >
                          {rmsLinkData.href}
                        </a>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end gap-3 mt-4">
                      <button
                        type="button"
                        className="btn-secondary"
                        onClick={() => setShowRmsLinkPopup(false)}
                      >
                        Close
                      </button>

                      <button
                        type="button"
                        className="btn-primary"
                        onClick={() => {
                          navigator.clipboard.writeText(rmsLinkData.href);
                          setToastData({
                            toastShow: true,
                            toastType: "success",
                            toastString: "Link copied to clipboard",
                          });
                        }}
                      >
                        Copy Link
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* {editProperty.length > 0 && (
              <UpdateProperty
                setShowUpdatePropertyModal={setshowUpdatePropertyModal}
                blocksList={blocksList}
                editPropertyDetails={editProperty[0]}
                clientId={clientObj.clientId}
                handleGetAllPropertyByClinetID={handleGetAllPropertyByClinetID}
                cityList={city}
                inspectorList={inspectorList}
                approverList={approverList}
                setToastData={setToastData}
              />
            )} */}

            <Toaster
              show={toastData.toastShow}
              toastType={toastData.toastType}
              title={toastData.toastString}
              theme={"dark"}
              position="top-center"
              closeButton={closeButton}
            />
          </>
          {/* // )} */}
        </div>
      )}
    </>
  );
};

export default AddProperty;
